import React from "react";
import styled from "styled-components";

const Description = styled.p`
  font-size: 16px;
  margin-bottom: 10px;
`;

const DescriptionTextOne = ({ name, t }) => {
  switch (name) {
    case "Klimat":
      return (
        <Description>
          {t("Poängen visar vilken klimatpåverkan produkten har jämfört med andra livsmedelsprodukter i databasen. Klimatpoängen baseras på produktens totala utsläpp av växthusgaser (CO2e) och presenteras på en skala mellan 1-100. Ett hållbart val är en produkt med en hög poäng, vilket betyder att produkten har lägre klimatpåverkan jämfört med andra livsmedelsprodukter med lägre poäng. Mat är en av de största anledningarna till utsläpp av växthusgaser och klimatförändringar. Enligt FN kommer ungefär en tredjedel av alla utsläpp av växthusgas som uppstår av mänsklig aktivitet från vår produktion, transport, tillredning, konsumtion och försäljning av mat.")}
        </Description>
      );
    case "Social rättvisa":
      return (
        <>
        <Description>
          {t("Social rättvisa handlar om i vilken mån människor kan nå sin fulla potential i samhället de lever i. Det kan till exempel gälla tillgång till utbildning, arbete och vård. Ett rättvist samhälle bygger på jämlikhet och ett gemensamt ansvar för alla individers välbefinnande och möjligheter i livet. Inget samhälle i världen kan sägas vara helt rättvist och på många platser råder djupa orättvisor mellan olika delar av befolkningen.")}
        </Description>
        <Description>
        {t("Värdet beräknas utifrån produktionslandets värde i Bertelsmann-stiftelsens index för social rättvisa (Bertelsmann Stiftung Social Justice Index). Bertelsmann-stiftelsen är en oberoende tysk stiftelse vars syfte bland annat är att främja forskning och vetenskap, kultur och utbildning. Värdet anges på en skala från 1–100. Ju högre värde, desto mer rättvist samhälle.")}
      </Description>
      </>
      );
    case "Vatten":
      return (
        <Description>
        {t("Skalan 1–100 visar, ju högre värde, desto mindre vatten krävs för att producera produkten.")}
      </Description>
      );
    case "Antibiotikaresistens":
      return (
        <>
        <Description>
          {t("Antibiotika är läkemedel som används för att behandla bakterieinfektioner. Tyvärr kan bakterier utveckla resistens (motståndskraft) mot läkemedlen, vilket gör dem mindre effektiva eller till och med overksamma. Ju mer antibiotika som finns i omlopp i miljön, desto större är risken att bakterier utvecklar resistens. En alltför stor användning av antibiotika till livsmedelsproducerande djur är en viktig drivkraft för denna utveckling.")}
        </Description>
        <Description>
          {t("Värdet beräknas utifrån data om produktionslandets användning av antibiotika för djur. Data kommer årligen från projektet European Surveillance of Veterinary Antimicrobial Consumption (ESVAC), som drivs av den europeiska läkemedelsmyndigheten EMA (European Medicines Agency). Det är frivilligt för länder att rapportera in data till projektet, som i dag omfattar data från 31 länder. Consupedias värde anges på en skala från 1–100. Ju högre värde desto mindre risk för att framställningen av produkten har bidragit till uppkomst av antibiotikaresistens.")}
        </Description>
        </>
      );
    case "Transport":
      return (
        <>
        <Description>
          {t("Vår mat är en global handelsvara som säljs och transporteras mellan olika delar av världen. Studier visar att transport av ingredienser och livsmedel står för nästan en femtedel av alla utsläpp av växthusgas inom matsystemet.")}
        </Description>
        <Description>
          {t("Värdet beräknas utifrån hur långt produkten måste transporteras för att nå Sverige. Värdet anges på en hundragradig skala. Ju högre värde, desto kortare transportsträcka.")}
        </Description>
        </>
      );
    case "Landanvändning":
      return (
        <Description>
          {t("Värdet anges på en skala från 1–100. Ju högre värde, desto mindre landyta krävs för att framställa produkten.")}
        </Description>
      );
    case "Bekämpningsmedel":
      return (
        <Description>
          {t("I stora delar av världen används bekämpningsmedel som är skadliga för människor, djur och natur. Många av de värsta bekämpningsmedlen är förbjudna i Sverige och EU men används fortfarande i låginkomstländer där lagarna inte är lika stränga.")}
        </Description>
      );
    case "Övergödning":
      return (
        <Description>
          {t("Konstgödsel spelar en fundamental roll i den globala matproduktionen. Eftersom stora  mängder näringsämnen (främst kväve och fosfor) läcker från jordbruk ut i färskvattensystem och hav leder användandet till övergödning vilket orsakar allvarliga skador på miljön.")}
        </Description>
      );
    case "Barnarbete":
      return (
        <Description>
          {t("I världens fattigaste länder utför mer än vart fjärde barn arbete som är skadligt för deras hälsa och utveckling. International Labor Organization, ILO definierar barnarbete som \"arbete som berövar barn (alla individer under 18 år) deras barndom, potential och värdighet, och som är skadligt för deras fysiska och/eller mentala utveckling\".")}
        </Description>
      );
    case "Djurvälfärd":
      return (
        <>
        </>
      );
    case "Arbetsförhållanden":
      return (
        <Description>
          {t("Matproduktion är en global industri som sysselsätter en stor del av jordens befolkning. För många är arbetsförhållandena dåliga och krävande. Goda arbetsförhållanden innebär inte bara att arbetstagaren har en fysiskt säker arbetsmiljö, det innefattar även skälig ersättning för rimliga arbetstider, rätten att organisera sig i fackförbund och anställningstrygghet.")}
        </Description>
      );
    case "Jämlikhet":
      return (
        <>
        <Description>
          {t("I ett hållbart samhälle är resurser och rättigheter tillgängliga på samma villkor för alla människor. Tyvärr ser det inte ut så idag. Ojämlikhet skapar lidande för stora delar av världens befolkning och utgör en grogrund för konflikter.")}
        </Description>
        <Description>
        {t("Produktionslandets värde anges på en skala från 1–100. Ju högre värde, desto mer jämlikt samhälle.")}
      </Description>
      </>
      );
    case "Lokalbefolkning":
      return (
        <Description>
          {t("En stor del av världens livsmedelssystem är beroende av produkter och råvaror från länder vars befolkning har ett dåligt skydd från rättssystemet när det gäller bland annat kriminalitet, våld och äganderätt till land. Parametern Lokalbefolkning ger ett mått på hur rättssäkert samhället är där dina livsmedel har producerats.")}
        </Description>
      );
    default:
      return "";
  }
};

export default DescriptionTextOne;
